/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WithdrawalPurchase = {
    /**
     * Purchase ID
     */
    id?: string;
    /**
     * Withdrawal ID
     */
    withdrawalId?: string;
    /**
     * Item ID being purchased
     */
    itemId?: string;
    /**
     * Name of the item
     */
    itemName?: string;
    /**
     * Purchase price
     */
    price?: number;
    /**
     * Purchase status (0=PENDING, 1=PURCHASED, 2=FAILED)
     */
    status?: WithdrawalPurchase.status;
    /**
     * Creation timestamp
     */
    createdAt?: string;
    /**
     * Last update timestamp
     */
    updatedAt?: string;
};
export namespace WithdrawalPurchase {
    /**
     * Purchase status (0=PENDING, 1=PURCHASED, 2=FAILED)
     */
    export enum status {
        '_0' = 0,
        '_1' = 1,
        '_2' = 2,
    }
}

